import { LaunchAdSerializer } from "@models/serializers/launchAdSerializer";
import { httpRequest } from "@services/http";

export class CommandListAdsInAudience {
  async run(launchId: number, adGroupId: number, expand?: string, status?: string) {
    const base = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/ads/`;
    const params = new URLSearchParams();
    if (expand) params.set("expand", expand);
    if (status) params.set("status", status);
    const qs = params.toString();
    const url = qs ? `${base}?${qs}` : base;
    const response = await httpRequest<any>(url, {
      method: "GET",
    });
    return this.deserialize(response);
  }

  deserialize(data: any) {
    // AdGroupAdSchema returns { id (AdGroupAd.id), launch_ad_id, launch_ad_status, ... }.
    // Remap to the LaunchAd shape the kanban consumes: use launch_ad_id as the
    // primary id (needed for PATCH /launch-ads/{id}/) and launch_ad_status as status.
    const remapped = (data ?? []).map((item: any) => ({
      ...item,
      id: item.launch_ad_id,
      status: item.launch_ad_status,
    }));
    return new LaunchAdSerializer().deserializeList(remapped);
  }
}
